import { XHR_TIMEOUT } from '../../../environments/environment';

/** File, Blob, バイナリ等に関するメソッドをまとめるクラス */
export class UtilFile {

  blobURLtoBlob(blobURL: string): Promise<any> {
    return new Promise(resolve => {
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
          resolve(xhr.response as Blob);
        }
      };
      xhr.open('GET', blobURL);
      xhr.timeout = XHR_TIMEOUT;
      xhr.send();
    });
  }

  blobToBinaryString(blob: Blob): Promise<any> {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result as string);
      };
      reader.readAsBinaryString(blob);
    });
  }

  blobURLToArrayBuffer(blobURL: string): Promise<any> {
    return new Promise(resolve => {
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'arraybuffer';
      xhr.onload = () => {
        if (xhr.readyState === 4 && xhr.status === 200 ) {
          resolve(xhr.response as ArrayBuffer);
        }
      };
      xhr.open('GET', blobURL);
      xhr.timeout = XHR_TIMEOUT;
      xhr.send();
    });
  }

  /** CSV文字列をJSONに変換 */
  csvStringToJson(csvStr: string, userOptions: any = null): any {
    if (typeof csvStr !== 'string') {
      return null;
    }

    const options = { header : 0, columnName : [], ignoreBlankLine : true };

    if (userOptions) {
        if (userOptions.header) {
          options.header = userOptions.header;
        }
        if (userOptions.columnName) {
          options.columnName = userOptions.columnName;
        }
    }

    const rows = csvStr.split('\n');
    let json = [], line = [], row = '', data = {};
    let i, len, j, len2;

    for (i = 0, len = rows.length; i < len; i++) {
        if ((i + 1) <= options.header) {
          continue;
        }
        if (options.ignoreBlankLine && rows[i] === '') {
          continue;
        }

        line = rows[i].split(',');

        if (options.columnName.length > 0) {
            data = {};
            for (j = 0, len2 = options.columnName.length; j < len2; j++) {
                if (typeof line[j] !== 'undefined') {
                    row = line[j];
                    row = row.replace(/^"(.+)?"$/, '$1');
                } else {
                    row = null;
                }

                data[options.columnName[j]] = row;
            }
            json.push(data);
        } else {
            json.push(line);
        }
    }
    return json;
  }

  /** JSONをオブジェクトに変換 */
  jsonArrayToObject(jsonArray: any[]): any[] {
    if (!jsonArray) {
      return null;
    }

    const objectArray = [];
    jsonArray.forEach((value, i) => {
      if (i >= 1) {
        const object = {};
        jsonArray[0].forEach((key, j) => {
          const newValue = value[j] ? value[j].trim() : value[j];
          object[key.trim()] = newValue;  // CSVをJSONに変えた際、末尾カラム名、末尾値に"\r"が入ってしまうのでtrim()で除去する
        });
        objectArray.push(object);
      }
    });
    return objectArray;
  }

}
